export default class RobotsEventDispatch {
  constructor(base_url) {
    this.post_url = base_url + "/webhooks/events/"
  }

  send(event_type, args) {
    var params = new Object();

    params['event_type'] = event_type
    if (args['event_occurred_at'] == null) {
      params['event_occurred_at'] = (new Date()).toISOString();
    }

    var opts = this.mergeOptions(params, args)

    var xhttp = new XMLHttpRequest();
    xhttp.open("POST", this.post_url, true);
    xhttp.setRequestHeader("Content-Type", "application/JSON");
    xhttp.send( JSON.stringify(opts) );
  }

  mergeOptions(obj1, obj2){
    var obj3 = {};
    for (var attrname in obj1) { obj3[attrname] = obj1[attrname]; }
    for (var attrname in obj2) { obj3[attrname] = obj2[attrname]; }
    return obj3;
  }
}

// This class is instantiated once at page load time,
// like this:
// event_dispatch = new RobotsEventDispatch("http://localhost:3001");
//
// and then can be re-used anywhere by calling event_dispatch.send();
// like:
// event_dispatch.send('OFT::SpeciesPhotoViewed', { object_id: 1, email: "boolean@gmail.com" })
